// export const BACKEND_URL = process.env.API_URL;
export const BACKEND_URL = "https://api.3dlifestyle.ca/api/";
export const PRIVACY_POLICY = "https://3dlifestyle.ca/privacy-policy/";
export const LICENSE_AGREMENT = "https://3dlifestyle.ca/end-users-license-agreement/";
export const GOOGLE_API = "AIzaSyATqiD9Stu2kfdE1OZaO66J9_oV9rPtAR8";
